<template>
  <nav v-if='kirby.site.strings' :class='{border : size!="smartphone" }'>
    <hamburger v-if='size=="smartphone"' :active.sync='active' />
    <section :class='{mobilemenu : size=="smartphone", active : active }'>
      <router-link @click.native='active=false' :to='"/"+link' v-for="(link, index) in kirby.site.content.menu"  :key="index">
        <h1 v-html='pageFromURI(link).strings.title' />
      </router-link>
    </section>
  </nav>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  data: function(){
    return {
      size: false,
      active: false
    }
  },
}
</script>

<style scoped>

  svg {
    position: fixed;
    right: 2rem;
    top: 3rem;
    z-index: 5;
  }

  section.mobilemenu {
    transition: opacity 0.25s ease-in-out 0.5s;
  }

  section.mobilemenu.active {
    opacity: 1;
  }

  section.mobilemenu:not(.active) {
    opacity: 0;
    pointer-events: none;
  }

  section.mobilemenu {
    position: fixed;
    background-color: var(--gray);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-content : center;
    justify-content: center;
  }
  section.mobilemenu a {
    height: 2em;
    text-align: center;
    display: block;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
  section.mobilemenu a::before {
    content: '';
  }
  section.mobilemenu * {
    color: var(--white);
  }
  nav {
    position: fixed;
    z-index: var(--navz);
    top: var(--navtop);
    right: 0;
    padding: var(--navpadding);
  }
  nav.border {
    border-bottom: var(--thinline);
    border-left: 3px solid var(--gray);
    background-color: var(--white);
  }
  nav.border::before {
    content: '';
    display: inline-block;
    background-color: white;
    position: absolute;
    top: -2.5rem;
    left: -5px;
    height: 2.5rem;
    width: calc(100% + 5px);
    z-index: 0;
  }
  nav a {
    display: inline-block;
    font-size: var(--large);
    line-height: 1em;
    margin-top: 0.25rem;
  }
  nav a * {
    color: var(--gray);
    will-change: color;
    transition: color 0.3s ease-in-out;
  }
  nav:not(:hover) a.router-link-exact-active h1 {
    color: var(--darkgray);
  }
  nav a:hover h1 {
    color: var(--darkgray);
  }
  @media screen and (min-width: 700px) {
    a+a::before {
      font-family: Face;
      font-size: inherit;
      content: ', ';
      width: 0.25em;
      display: inline-block;
      margin-right: 0.1em;
      line-height: inherit;
    }
  }
  h1 {
    font-size: var(--navtextsize);
    display: inline-block;
    line-height: inherit;
  }
</style>
